<template lang="pug">
  page
    section.pageheader
      .container#info-container
        h1 Terms & Conditions 

      .container
        .row
          .col-sm-12
            p 
              b About Business to Startups 
            p Business to startups  is an initiative by Kerala Startup Mission to scout products which are relevant or adaptable for various Industry/ Industry bodies. 

            p 
              b Purpose
            p The purpose of Business to Startups is to facilitate startups to get connected with  Industry or Industry bodies 

            p 
              b Consideration of the product 
            p Kerala Startup Mission plays the role of a facilitator to connect the startups with interested industry or the industry/industry bodies that have given the problem statement. The selection of the product completely vests with the Industry / Industry body themselves. 

            p 
              b Process Flow
            p The applications shall be evaluated by a team of experts /technologists from the respective Industry and the startups selected by them will be invited for further interaction. 

            p 
              b Note
              ul
                li Acceptance of applications is solely decision by the expert panel of the Industry/ Industry body
                li KSUM will stand indemnified, in case of any dispute



</template>

<script>
// @ is an alias to /src
import page from '@/components/frontend/page'
export default {
  name: 'Home',
  components: {
    page
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/_mixins';
#info-container{
  padding-top: 150px;
 h1{
    font-weight: 400;
    font-size: 1.8rem;
  }
}
.pageheader{
  @include my_bp(sm){
    padding-bottom: 350px;
  }
}
p{
  text-align: justify;
}
</style>